import { Directive, ElementRef, Input } from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { InputUtils } from './InputUtils';

@Directive({
    selector: '[inputNormalize]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: InputNormalizeDirective
        }
    ]
})
export class InputNormalizeDirective implements ControlValueAccessor {

    @Input() inputNormalize: 'alfa' | 'numeric' | 'alfanum' | 'email';
    @Input() formControlName: string;

    onChange(value: any) { }
    onTouched() { }

    private _control: NgControl;

    constructor(private _el: ElementRef) {
    }

    writeValue(value: any): void {
        this._el.nativeElement.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    ngAfterViewInit() {
        this._el.nativeElement.addEventListener('input', (event) => this._delegate(event));
        this._el.nativeElement.addEventListener('paste', (event) => this._delegate(event));
        this._patchValueListener();
    }

    execute($event) {
        switch (this.inputNormalize) {
            case 'alfa': InputUtils.onInput($event, 'alfa'); break;
            case 'numeric': InputUtils.onInput($event, 'numeric'); break;
            case 'alfanum': InputUtils.onInput($event, 'alfanum'); break;
            case 'email': InputUtils.onInput($event, 'email'); break;
        }
    }

    private _caller(event) {
        this.execute.apply(this, [event]);
    }

    private _delegate(event) {
        return this._caller(event);
    }

    private _patchValueListener() {
        InputUtils
            .updated
            .pipe(filter(target => this._el.nativeElement === target))
            .subscribe(target => {
                if (!target.value) this.onChange(null);
                this.onChange(target.value.toUpperCase().trim());
            });
    }
}
